export default __webpack_public_path__ + "static/media/Circuit of the Void.d306011e.jpg";